import request from "@/utils/request";

/**
 * 筛选获取类型
 *
 * @description 查询筛选类型
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function sysDict_queryItemList(playload) {
  return request({
    url: "/api/v2/sysDict/queryItemList",
    method: "POST",
    data: playload
  });
}
/**
 * 系统配置参数接口
 *
 * @description 系统配置参数接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function querySystemConfig(playload) {
  return request({
    url: "/api/lottery/sysDict/querySystemConfig",
    method: "POST",
    data: playload
  });
}

/**
 * 173.初始化Geetest行为验证
 *
 * @description 173.初始化Geetest行为验证
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function initGtCapthca(playload, config) {
  return request({
    url: "/api/v2/captcha/initGtCapthca",
    method: "POST",
    data: playload,
    noEncrypt: false,
    ...config
  });
}

export async function queryStrategySettingList(playload) {
  return request({
    url: "/api/v2/strategy/queryStrategySettingList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    userId: true
  });
}
export async function queryStrategyRecordList(playload) {
  return request({
    url: "/api/v2/strategy/queryStrategyRecordList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    userId: true
  });
}

export async function buyStrategy(playload) {
  return request({
    url: "/api/v2/strategy/buyStrategy",
    method: "POST",
    data: playload,
    userId: true
    // noEncrypt: true,
  });
}

export async function queryMyStrategyRecord(playload) {
  return request({
    url: "/api/v2/strategy/queryMyStrategyRecord",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}

export async function getStrategySetting(playload) {
  return request({
    url: "/api/v2/strategy/getStrategySetting",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
